import IndustryDetailPage from "@/pages/industries/components/IndustryDetailPage";

export default function EcommercePage() {
  return <IndustryDetailPage slug="ecommerce" />;
}